
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import * as Sentry from "@sentry/react";
import { useState } from "react";

interface QueryProviderProps {
  children: React.ReactNode;
}

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        meta: {
          onError: (error) => {
            Sentry.captureException(error);
          },
        },
        retry: 1,
        staleTime: 60000, // 1 minute cache by default (increased from 30s)
        gcTime: 300000, // 5 minutes 
        refetchOnWindowFocus: false,
        refetchOnMount: true,
      },
      mutations: {
        meta: {
          onError: (error) => {
            Sentry.captureException(error);
          },
        },
        retry: 1,
      },
    },
  }));

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Include DevTools only in development */}
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};

export default QueryProvider;
